<template>
  <chart-layout :title="title" :yAxis="yAxis" :xAxis="xAxis">
    <bar-graph
      :chart-data="data"
      :chart-id="chartIdOverride"
      :type="type">
    </bar-graph>
  </chart-layout>
</template>

<script>
import BarGraph, {types} from '@/components/graphs/BarGraph'
import ChartLayout from '@/components/layouts/ChartLayout'

export default {
  components: {
    BarGraph,
    ChartLayout
  },
  props: {
    chartIdOverride: {
      type: String,
      default: 'age-graph'
    },
    data: {
      type: Object
    },
    meanAge: {
      type: String
    }
  },
  data () {
    return {
      yAxis: 'Viewship %',
      xAxis: 'Age Groups',
      type: types.PERCENTAGE
    }
  },
  computed: {
    title () {
      return `Age Distribution (10 year ranges) (Mean Age ${this.meanAge})`
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// AgeDistributionGraph.vue?c78f1fa6